import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ListItem } from '../typography';

const Bullet = styled.div`
  color: ${props => props.theme.color.textDark};
  padding-top: 2px;

  &::before {
    content: '\f111';
    font-family: FontAwesome;

    ${props =>
    props.bullet === 'black' &&
      `
        font-size: 0.7em;
      `};
    ${props =>
    props.bullet === 'orange' &&
      `
        color: orange;
        font-size: 0.7em;
      `};
    ${props =>
    props.bullet === 'icon_caution' &&
      `
        color: red;
        content: '\f071';
        font-size: 1.5em;
      `};
    ${props =>
    props.bullet === 'icon_note' &&
      `
        content: '\f05a';
        font-size: 1.5em;
      `};
  }
`;

const Instruction = styled(ListItem)`
  color: ${props => props.theme.color.textDark};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeight.extralight};
  margin: 0 0 20px;
  padding-left: 10px;

  ${props =>
    props.bullet === 'black' &&
    `
    padding-left: 16px;
  `};
  ${props =>
    props.bullet === 'icon_caution' &&
    `
    color: red;
    font-weight: ${props.theme.fontWeight.bold};
    padding-left: 6px;
  `};
  ${props =>
    props.bullet === 'icon_note' &&
    `
    font-weight: ${props.theme.fontWeight.semibold};
  `};
`;

const Li = styled.li`
  display: flex;
  flex-direction: row;
  list-style-type: none;
`;

class Line extends Component {
  static propTypes = {
    line: PropTypes.object
  };

  createMarkup(pageText) {
    return { __html: pageText };
  }

  render() {
    const { bullet, text } = this.props.line;
    // strip triple quotes surrounding the text
    const pageText = text.replace(/(^'''|'''$)/g, '');
    return (
      <Li>
        <Bullet bullet={bullet} />
        <Instruction
          dangerouslySetInnerHTML={this.createMarkup(pageText)}
          bullet={bullet}
        />
      </Li>
    );
  }
}

export default Line;



// WEBPACK FOOTER //
// ./src/components/Steps/Line.js